import { gql } from '@apollo/client'

export default gql(`
    mutation deleteGenre($id: ID!, $name: String, $project: String) {
        deleteGenre(
                id: $id,
                name: $name,
                project: $project
        ) {
            id
            name
            assetCount
        }
    }`
)
